<template>
  <div class="go1-loader">
   
  </div>
</template>